import { Observable } from 'rxjs'
import { penultimate } from 'utils'
import { StateObservable, combineEpics, ofType } from 'redux-observable'
import { GlobalState } from 'store'
import { SelectionActionTypes, SelectionActions } from 'store/selection'
import { withLatestFrom, filter, map } from 'rxjs/operators'
import { BTQAction } from 'epics'
import { RxWebSocketReadyState } from 'messaging'
import { ConnectionDependencies } from './connectionEpic'

type CloseOrganisationProfilesAction = ReturnType<typeof SelectionActions.closeOrganisationProfiles>
export function closeOrganisationProfilesEpic(
  action$: Observable<BTQAction>,
  state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return action$.pipe(
    ofType<BTQAction, SelectionActionTypes.CLOSE_ORGANISATION_PROFILES, CloseOrganisationProfilesAction>(
      SelectionActionTypes.CLOSE_ORGANISATION_PROFILES
    ),
    withLatestFrom(state$, state$.pipe(penultimate())),
    filter(([action, _currentState, previousState]) => selectedOrganisationIsClosing(action, previousState)),
    map(([action, currentState, previousState]) =>
      SelectionActions.setOrganisationId(getNextSelectedOrganisationId(action, currentState, previousState))
    )
  )
}

export function setOrganisationIdEpic(
  action$: Observable<BTQAction>,
  _state$: StateObservable<GlobalState>,
  _dependencies: {}
): Observable<BTQAction> {
  return action$.pipe(
    ofType(SelectionActionTypes.SET_ORGANISATION_ID),
    map(_action => SelectionActions.clearAllCollectionIds())
  )
}

export function resetOrganisationOnSocketOpenEpic(
  _action$: Observable<BTQAction>,
  _state$: Observable<GlobalState>,
  dependencies: ConnectionDependencies
): Observable<BTQAction> {
  return dependencies.connection.status$.pipe(
    filter(status => status.readyState === RxWebSocketReadyState.Open),
    map(() => SelectionActions.setOrganisationId(null))
  )
}

function selectedOrganisationIsClosing(action: CloseOrganisationProfilesAction, previousState: GlobalState) {
  const previousSelections = previousState.selectionStore.windows[action.payload.windowId]
  if (previousSelections.organisationId === null) {
    return false
  }
  return action.payload.organisationIds.includes(previousSelections.organisationId)
}

function getNextSelectedOrganisationId(action: CloseOrganisationProfilesAction, currentState: GlobalState, previousState: GlobalState) {
  const currentSelections = currentState.selectionStore.windows[action.payload.windowId]
  const previousSelections = previousState.selectionStore.windows[action.payload.windowId]

  // if new state has no ids return null
  if (currentSelections.openOrganisationIds.length === 0 || previousSelections.organisationId === null) {
    return null
  }

  // find index of selected org id in old state
  const index = previousSelections.openOrganisationIds.indexOf(previousSelections.organisationId)

  // go up from old id until new state includes id - if found return it
  for (let i = index + 1; i < previousSelections.openOrganisationIds.length; i++) {
    if (currentSelections.openOrganisationIds.includes(previousSelections.openOrganisationIds[i])) {
      return previousSelections.openOrganisationIds[i]
    }
  }

  // go down from old id until new state includes id - if found return it
  for (let i = index - 1; i > -1; i--) {
    if (currentSelections.openOrganisationIds.includes(previousSelections.openOrganisationIds[i])) {
      return previousSelections.openOrganisationIds[i]
    }
  }

  return null
}

export const adminOrganisationEpic = combineEpics(closeOrganisationProfilesEpic, setOrganisationIdEpic, resetOrganisationOnSocketOpenEpic)
